import React from "react";
import { Lock } from "lucide-react";

/** Held bubble copy: extract incomplete vs other inspection incomplete vs provider. */
export function HeldResponseNotice({ msg }) {
  const inspectHold =
    msg?.remediation?.rule === "inspection_incomplete"
    || msg?.steps?.detection?.inspection_incomplete;
  const extractHold =
    msg?.remediation?.extract_incomplete === true
    || msg?.steps?.detection?.extract_incomplete === true;

  if (inspectHold && extractHold) {
    return (
      <div className="rounded-lg border border-warn/40 bg-warn/10 p-3" data-testid="held-response">
        <div className="flex items-center gap-2 text-sm font-semibold text-warn" data-testid="held-inspection-incomplete">
          <Lock className="h-4 w-4" /> Held. Inspectie niet volledig
        </div>
        <p className="mt-1 text-xs text-slate-400">
          Tekst geëxtraheerd is niet hetzelfde als inhoud geïnspecteerd. Geen generatiecall.
          Verwijder incomplete bijlagen, upload een leesbare vervanging en verstuur opnieuw.
        </p>
      </div>
    );
  }
  if (inspectHold) {
    return (
      <div className="rounded-lg border border-warn/40 bg-warn/10 p-3" data-testid="held-response">
        <div className="flex items-center gap-2 text-sm font-semibold text-warn" data-testid="held-inspection-incomplete">
          <Lock className="h-4 w-4" /> Held. Inspectie niet volledig
        </div>
        <p className="mt-1 text-xs text-slate-400">
          Gevoelige-data-inspectie is niet afgerond. Geen generatiecall. Probeer het verzoek opnieuw.
          Deterministische hits (indien aanwezig) blijven gelden.
        </p>
      </div>
    );
  }
  return (
    <div className="rounded-lg border border-warn/40 bg-warn/10 p-3" data-testid="held-response">
      <div className="flex items-center gap-2 text-sm font-semibold text-warn">
        <Lock className="h-4 w-4" /> Held. Geen geschikte provider beschikbaar
      </div>
      <p className="mt-1 text-xs text-slate-400">Zet een bruikbare provider aan in Policy Builder om verder te gaan.</p>
    </div>
  );
}
